import { render, staticRenderFns } from "./CollectionBanner.vue?vue&type=template&id=05c5c220&name=collection-banner&"
import script from "./CollectionBanner.vue?vue&type=script&lang=js&"
export * from "./CollectionBanner.vue?vue&type=script&lang=js&"
import style0 from "./CollectionBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports